import Breadcrumb from './src/Breadcrumb'
import BreadcrumbItem from './src/components/breadcrumb-item/BreadcrumbItem'
export { BreadcrumbItem }
export default Breadcrumb
